<template>
  <div>
      <div class="site-section" id="mint">
    <div class="container pt-5" id="mint-container-outer">
      <div class="columns mint-area">
          <MintBook1 />
          <MintBook2 />
          <MintBook3 />
          <MintBook4 />
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import MintBook1 from "../../components/MintBook1.vue";
import MintBook2 from "../../components/MintBook2.vue";
import MintBook3 from "../../components/MintBook3.vue";
import MintBook4 from "../../components/MintBook4.vue";

export default {
  name: "app",
  components: {
    MintBook1,
    MintBook2,
    MintBook3,
    MintBook4
  }
};
</script>

<style scoped>
.site-section {
    font-family: 'Poppins', arial, sans-serif;
}
  .mint-area {
    text-align: center;
    padding-top: 5px;
  }

    .mint-area .column {
      margin: 5px;
      background: rgb(51, 51, 51);;
    }
</style>